module.exports = __webpack_public_path__ + "static/img/icon5.b86db20.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/fxcp_result/images/icon5.png
// module id = MfAJ
// module chunks = 21